var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#75cede;}.cls-2{fill:#00a6bc;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 6",
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.64,6,16,14.77,28.36,6a1,1,0,0,1,1.08,0A4.08,4.08,0,0,0,26.92,5H5.08a4.08,4.08,0,0,0-2.52.9A1,1,0,0,1,3.64,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.56,6a.86.86,0,0,1,.19.19,1,1,0,0,1-.23,1.39L16.58,16.81a1,1,0,0,1-1.16,0L2.48,7.57a1,1,0,0,1-.23-1.39A.86.86,0,0,1,2.44,6,4.08,4.08,0,0,0,1,9.08V22.92A4.08,4.08,0,0,0,5.08,27H26.92A4.08,4.08,0,0,0,31,22.92V9.08A4.08,4.08,0,0,0,29.56,6ZM13.78,18.81,3.64,26.05a1,1,0,0,1-.58.19,1,1,0,0,1-.81-.42,1,1,0,0,1,.23-1.39l10.14-7.24a1,1,0,0,1,1.16,1.62Zm16,7a1,1,0,0,1-.81.42,1,1,0,0,1-.58-.19L18.22,18.81a1,1,0,1,1,1.16-1.62l10.14,7.24A1,1,0,0,1,29.75,25.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1afcc4e1c6ee20f2c57c67ebe95bbbdf.svg";
export { ForwardRef as ReactComponent };